import React from 'react';
import ReportDataPage from './ReportDataPage';

const cols = [
  { key: 'partNumber', header: 'Part number' },
  { key: 'partDescription', header: 'Description' },
  { key: 'binLocation', header: 'Bin' },
  { key: 'systemQuantity', header: 'System qty' },
  { key: 'countedQuantity', header: 'Counted qty' },
  {
    key: 'variance',
    header: 'Variance',
    format: (v) => (v == null || v === '' ? '' : String(v)),
  },
  {
    key: 'recordedAt',
    header: 'Recorded',
    format: (v) => (v ? new Date(v).toLocaleString() : ''),
  },
];

export default function CycleCountReport() {
  return (
    <ReportDataPage
      title="Cycle count report"
      subtitle="Stock count lines recorded from ChesiWMS-Lite (system vs counted quantity and variance)."
      endpoint="/api/reports/cycle-count-records"
      exportFileSlug="cycle-count-report"
      columns={cols}
      emptyIcon="🔢"
    />
  );
}
